import { useState } from 'react'
import { QrCode, Link2, X, Loader2 } from 'lucide-react'
import ConfirmModal from '@/widgets/ConfirmModal'
import Select from 'react-select'
import { motion, AnimatePresence } from 'framer-motion'

const opts = g => [
  { value: '', label: '-- เลือกกลุ่มผู้เรียน --' },

  ...g.map(x => ({ value: x.id, label: x.name }))
]

export default function InviteModal({ groups, onGenerate, onClose }) {
  const [gid, setGid] = useState({ value: '', label: '-- เลือกกลุ่มผู้เรียน --' })
  const [quota, setQuota] = useState(0)
  const [expireHours, setExpireHours] = useState(48)

  const [loading, setLoading] = useState(false)
  const [alertMsg, setAlertMsg] = useState('')
  const alert = m => setAlertMsg(m)

  const generate = async () => {
    if (!gid.value) return alert('กรุณาเลือกกลุ่มผู้เรียนก่อน')
    setLoading(true)
    try {
      await onGenerate(gid.value, quota, expireHours)
      onClose()
    } catch {
      alert('สร้างลิงก์ไม่สำเร็จ')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <AnimatePresence>
        <motion.div
          key="ov"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/45 backdrop-blur-[2px] z-40"
        />
        <motion.div
          key="dlg"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="fixed z-50 inset-x-4 md:inset-x-0 mx-auto max-w-sm w-full bg-white rounded-xl shadow-2xl p-6 flex flex-col gap-5"
        >
          <button onClick={onClose} className="absolute right-3 top-3 text-gray-500 hover:text-gray-700">
            <X size={18} />
          </button>

          <h2 className="flex items-center gap-2 text-lg font-semibold">
            <QrCode size={20} />
            เชิญผ่านลิงก์ / QR-Code
          </h2>

          <div className="space-y-1 w-full">
            <label className="text-sm">กลุ่มผู้เรียน</label>
            <Select
              classNamePrefix="rs"
              options={opts(groups)}
              value={gid}
              onChange={setGid}
              isSearchable
            
            />
          </div>

          <div className="space-y-1 w-full">
            <label className="text-sm">จำกัดจำนวน (Quota, 0=unlimited) </label>
            <input
              type="number"
              min={1}
              value={quota}
              onChange={e => setQuota(Number(e.target.value))}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="เช่น 100"
            />
          </div>

          <div className="space-y-1 w-full">
            <label className="text-sm">อายุลิงก์ (ชั่วโมง)</label>
            <input
              type="number"
              min={1}
              value={expireHours}
              onChange={e => setExpireHours(Number(e.target.value))}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="48"
            />
          </div>

          {loading && (
            <p className="flex justify-center">
              <Loader2 className="animate-spin" />
            </p>
          )}

          <div className="flex justify-end gap-2">
            <button
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg px-4 py-2 text-sm"
              onClick={onClose}
            >
              ยกเลิก
            </button>
            <button
              disabled={!gid.value || loading}
              onClick={generate}
              className="inline-flex items-center gap-1 bg-primary hover:bg-secondary disabled:opacity-40 text-white rounded-lg px-4 py-2 text-sm"
            >
              <Link2 size={14} /> สร้างลิงก์ / QR
            </button>
          </div>
        </motion.div>
      </AnimatePresence>

      {alertMsg && (
        <ConfirmModal
          type="alert"
          title="แจ้งเตือน"
          message={alertMsg}
          onClose={() => setAlertMsg('')}
        />
      )}
    </>
  )
}
